/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const phraseListTableMessages = defineMessages({
    nameColumnHeader: {
        id: 'features.phraseListTable.nameColumnHeader',
        defaultMessage: 'Name'
    },
    typeColumnHeader: {
        id: 'features.phraseListTable.typeColumnHeader',
        defaultMessage: 'Type'
    },
    usedByColumnHeader: {
        id: 'features.phraseListTable.usedByColumnHeader',
        defaultMessage: 'Used by'
    },
    isActiveColumnHeader: {
        id: 'features.phraseListTable.isActiveColumnHeader',
        defaultMessage: 'Status'
    },
    isExchangeableText: {
        id: 'features.phraseListTable.isExchangeableText',
        defaultMessage: 'Interchangeable'
    },
    isNotExchangeableText: {
        id: 'features.phraseListTable.isNotExchangeableText',
        defaultMessage: 'Not Interchangeable'
    },
    isActiveText: {
        id: 'features.phraseListTable.isActiveText',
        defaultMessage: 'Enabled'
    },
    isInactiveText: {
        id: 'features.phraseListTable.isInactiveText',
        defaultMessage: 'Disabled'
    },
    emptyTablePlaceholder: {
        id: 'features.phraseListTable.emptyTablePlaceholder',
        defaultMessage: "You haven't created any features yet."
    },
    global: {
        id: 'features.phraseListTable.global',
        defaultMessage: 'Global'
    },
    phraseList: {
        id: 'features.phraseListTable.phraseList',
        defaultMessage: 'Phrase List'
    },
    entity: {
        id: 'features.phraseListTable.entity',
        defaultMessage: 'entity'
    },
    intent: {
        id: 'features.phraseListTable.intent',
        defaultMessage: 'intent'
    }
});
